import { ColorEnum } from '@/constants/color'
import { isIOS } from '@/constants/environment'
import { StyleSheet } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

export const padding = 16

export const containerStylesheet = createStyleSheet((_, { insets }) => ({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: padding,
        paddingBottom: isIOS ? Math.max(padding, insets.bottom) : padding + insets.bottom,
        variants: {
            layout: {
                compact: {
                    gap: 12,
                },
                extended: {
                    gap: 16,
                },
            },
            cartEmpty: {
                true: {
                    paddingHorizontal: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    gap: 0,
                },
            },
        },
    },
}))

export const iconButtonSize = 44
export const actionButtonWidth = 344
export const paymentTypeRowGap = 8
export const paymentTypeButtonMinHeight = 44

export const actionsStylesheet = createStyleSheet({
    container: {
        width: '100%',
        alignItems: 'center',
        paddingHorizontal: padding,
        gap: 12,
    },
    actionsRow: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
        gap: 8,
    },
    paymentTypesRow: {
        flexDirection: 'row',
        gap: paymentTypeRowGap,
        width: '100%',
        variants: {
            layout: {
                extended: {
                    maxWidth: actionButtonWidth,
                },
                compact: {
                    maxWidth: '100%',
                },
            },
        },
    },
    paymentTypesRowRight: {
        justifyContent: 'flex-end',
    },
    extraPaymentTypesContainer: {
        width: '100%',
        alignSelf: 'center',
        variants: {
            layout: {
                extended: {
                    maxWidth: actionButtonWidth,
                },
                compact: {
                    maxWidth: '100%',
                },
            },
        },
    },
    paymentTypeButton: {
        flexGrow: 1,
        flexBasis: 0,
        minHeight: paymentTypeButtonMinHeight,
        paddingHorizontal: 10,
        paddingVertical: 10,
        borderRadius: 4,
    },
    paymentTypeButtonThird: {
        flexGrow: 0,
        flexBasis: '33.33%',
        maxWidth: '33.33%',
    },
    extraPaymentTypesContent: {
        gap: 12,
    },
    paymentTypeLabel: {
        textTransform: 'uppercase',
    },
    actionButtonText: {
        textTransform: 'uppercase',
    },
    actionButton: {
        height: iconButtonSize,
        variants: {
            layout: {
                extended: {
                    width: actionButtonWidth,
                    maxWidth: actionButtonWidth,
                },
                compact: {
                    flexGrow: 1,
                    maxWidth: '100%',
                },
            },
        },
    },
    closeButton: {
        backgroundColor: ColorEnum.BRICK_500,
    },
})

const priceToPayMaxWidth = 344

export const priceToPayStyles = StyleSheet.create({
    container: {
        width: '100%',
        alignItems: 'center',
    },
    itemsContainer: {
        width: '100%',
        maxWidth: priceToPayMaxWidth,
        alignSelf: 'center',
    },
    itemsContent: {
        gap: 8,
        paddingBottom: 12,
    },
    itemRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 12,
    },
    itemLabel: {
        color: ColorEnum.GRAY_600,
        flexShrink: 1,
    },
    itemPrice: {
        color: ColorEnum.GRAY_600,
        textAlign: 'right',
        flexShrink: 1,
    },
    headerContainer: {
        width: '100%',
        paddingVertical: 8,
        paddingHorizontal: 16,
    },
    headerContent: {
        width: '100%',
        maxWidth: priceToPayMaxWidth,
        alignSelf: 'center',
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        flex: 1,
        color: ColorEnum.GRAY_900,
    },
    totalPrice: {
        flex: 1,
        textAlign: 'right',
        color: ColorEnum.GRAY_900,
    },
    chevron: {
        color: ColorEnum.GRAY_900,
    },
    divider: {
        height: 1,
        backgroundColor: ColorEnum.GRAY_300,
        marginHorizontal: 16,
        alignSelf: 'stretch',
    },
})
